import { Outlet } from "react-router";
import logo from "../assets/images/logo-white.svg";
import { Link } from "react-router-dom";
import AutoHeader from "../components/layout/AutoHeader";
import MenuItem from "../components/shared/MenuItem";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { SwapOutlined } from "@ant-design/icons";
import {
  BookOpenText,
  Building2,
  Columns3Cog,
  Grid2x2,
  LayoutPanelLeft,
  Users,
} from "lucide-react";
import { Tooltip } from "antd";

export default function AutoLayout() {
  const { user } = useContext(AuthContext);
  const menus = [
    {
      id: 1,
      isActive: true,
      access: [0, 1, 2, 3, 4, 5, 7, 8, 9],
      to: "/autoline/dashboard",
      name: "Dashboard",
      icon: <BookOpenText size={15} />,
    },
    {
      id: 1,
      isActive: true,
      access: [0, 1, 2, 3, 4, 5, 7, 8, 9],
      to: "/autoline/requests",
      name: "Requests",
      icon: <BookOpenText size={15} />,
    },
    {
      id: 2,
      isActive: false,
      access: [9],
      to: "/autoline/companies",
      name: "Legal Entities",
      icon: <Building2 size={15} />,
    },
    {
      id: 2,
      isActive: false,
      access: [9],
      to: "/autoline/units",
      name: "Business Units",
      icon: <LayoutPanelLeft size={15} />,
    },
    {
      id: 3,
      isActive: false,
      access: [9],
      to: "/autoline/modules",
      name: "Modules",
      icon: <Grid2x2 size={15} />,
    },
    {
      id: 4,
      isActive: false,
      access: [9],
      to: "/autoline/matrix",
      name: "Matrix",
      icon: <Columns3Cog size={15} />,
    },
    {
      id: 5,
      isActive: false,
      access: [9],
      to: "/autoline/users",
      name: "Users",
      icon: <Users size={15} />,
    },
  ];
  return (
    <div className="h-screen bg-gray-100 font-toyota text-xxs">
      <div className="flex h-full">
        {/* Sidebar */}
        <div className="w-48 flex-shrink-0 bg-karimjee min-h-screen border-r text-white">
          <div className="border-b border-karimjee-dark flex items-center justify-center h-14 bg-karimjee">
            <img src={logo} alt="Logo" width={110} />
          </div>
          <div className="p-2">
            <Tooltip title="Autoline Access">
              <Link
                to={"/change/requests"}
                className="flex items-center mb-2 px-2 py-1 hover:text-gray-200 border border-gray-500"
              >
                <SwapOutlined />
                <span className="hidden md:block mx-3">Change Form Request</span>
              </Link>
            </Tooltip>
            <div className="flex flex-col">
              {menus?.map((menu: any, index: number) => {
                if (menu?.access?.includes(user?.accessLevel)) {
                  return (
                    <MenuItem
                      to={menu.to}
                      icon={menu.icon}
                      key={index}
                      name={menu.name}
                      className="hidden md:block"
                    />
                  );
                }
              })}
            </div>
          </div>
        </div>
        {/* Main Content */}
        <div className="flex-1 w-full overflow-hidden flex flex-col">
          <AutoHeader />
          <div className="flex-1 overflow-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
